import React, {useRef} from 'react';
import './e-checkbox.scss';

const CheckBox = (props) => {
  const {value, name, required, label, onChange} = props;
  const checkBoxClassname = () => {
    const baseClassName = 'e-checkbox';
    return JSON.parse(value) === false ? baseClassName : `${baseClassName} ${baseClassName}_checked`
  };

  const checkbox = useRef(null);
    const handleClick = () => {
        checkbox.current.click();
    };
  return (
      <div>
          <input
              checked={JSON.parse(value)}
              value={value}
              className="input-box__input input-box__input_checkbox"
              id={name}
              required={required}
              name={name}
              onChange={onChange}
              type="checkbox"
              ref={checkbox}
          />
          <div onClick={handleClick} className={checkBoxClassname()}></div>
      </div>

  );
};

export default CheckBox;
